import axios from "axios";

export const Roles_URL = "api/roles";

export function getRoleById(roleId) {
  return axios.get(`${Roles_URL}/${roleId}`);
}

export function getAllRoles(limit, page, sortOrder = "desc", sortField = "created_at") {
  return axios.get(`${Roles_URL}?limit=${limit}&page=${page}&sortOrder=${sortOrder}&sortField=${sortField}`);
}

export function createRole(role) {
  return axios.post(`${Roles_URL}`, role);
}

export function updateRole(id, role) {
  return axios.patch(`${Roles_URL}/${id}`, role);
}

export function deleteRole(roleId) {
  return axios.delete(`${Roles_URL}/${roleId}`);
}
